<script lang="ts" setup>
const props = defineProps<{
  productId: string
}>()

const { t } = useI18n()
const prizeMoney = usePrizeMoney()
const { soldCount, repeatPurchaseCount, currentlyViewingCount } = useProductMetrics(props.productId)
const config = useRuntimeConfig()

const expressShippingTime = computed(() => {
  const min = +config.public.expressShippingTime.min
  const max = +config.public.expressShippingTime.max
  return { min, max }
})

const addTextContext = (text: string) => text.replace(/(\*\*)(.*?)(\*\*)/g, '<span>$2</span>')
</script>

<template>
  <section>
    <div class="mb-4 flex flex-col gap-y-1">
      <div class="flex items-center">
        <div class="flex items-center rounded py-1 pb-2">
          <div class="flex flex-col">
            <span class="text-lg text-success text-success font-bold">{{ t('product.in_stock') }}, {{ t('product.ships_immediately') }}</span>
            <div class="text-sm">
              <p class="text-slate-7">
                {{
                  t('product.fastest_delivery.label')
                }}: <span class="relative font-bold after:absolute after:bottom-0 after:left-0 after:right-0 after:h-[1px] after:translate-y-[3px] after:border-b after:border-slate-600 after:border-dashed after:content-['']">{{ t('delivery.within_n_working_days', expressShippingTime.min) }}</span>
                <LazyUiTooltipProvider>
                  <LazyUiTooltip>
                    <LazyUiTooltipTrigger>
                      <Icon name="i-mdi:information-variant-circle" class="ml1 text-base text-muted-foreground/50" />
                    </LazyUiTooltipTrigger>
                    <LazyUiTooltipContent>
                      <div class="max-w-xs">
                        {{
                          t('product.fastest_delivery.tooltip', [`${expressShippingTime.min} - ${expressShippingTime.max}`])
                        }}
                      </div>
                    </LazyUiTooltipContent>
                  </LazyUiTooltip>
                </LazyUiTooltipProvider>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="flex content-center items-start items-center">
        <Icon name="lucide:eye" class="flex-shrink-0 text-lg text-orange5" />
        <p
          class="ml2 text-xs text-muted-foreground sm:text-sm [&_span]:text-orange5 [&_span]:fw600"
          v-html="addTextContext(t('product.currently_viewing_n_customers', [currentlyViewingCount]))"
        />
      </div>

      <div class="flex items-start items-center">
        <Icon name="lucide:trophy" class="flex-shrink-0 text-lg text-orange5" />
        <p
          class="ml2 mt-0.5 text-xs text-muted-foreground sm:text-sm [&_span]:text-orange5 [&_span]:fw600"
          v-html="addTextContext(t('promotion.purchase_competition_prizes', [`**${prizeMoney}**`]))"
        />
      </div>

      <div class="flex items-start items-center">
        <Icon class="flex-shrink-0 text-lg text-red4" name="lucide:flame" />
        <p
          class="ml2 mt0.5 text-xs text-muted-foreground sm:text-sm [&>span]:text-red4 [&>span]:fw600"
          v-html="addTextContext(t('product.hot_item_sold_count', [soldCount]))"
        />
      </div>

      <div class="flex content-center items-start items-center">
        <Icon class="flex-shrink-0 text-lg text-blue5" name="lucide:thumbs-up" />
        <p
          class="ml2 mt-0.5 text-xs text-muted-foreground sm:text-sm [&>span]:text-blue5 [&>span]:fw600"
          v-html="addTextContext(t('product.customers_repeat_purchases', [repeatPurchaseCount]))"
        />
      </div>
    </div>

    <!--    <div -->
    <!--      class="flex items-center justify-center gap-2 rounded-md bg-orange-100 px-3 py-2 text-sm text-orange-700 font-medium" -->
    <!--    > -->
    <!--      <span> -->
    <!--        <Icon name="lucide:hourglass" /> -->
    <!--        Sleva končí za:</span> -->
    <!--      <span id="countdown" class="font-bold tabular-nums">09:59</span> -->
    <!--    </div> -->
  </section>
</template>
